import React from "react";
import {Dropdown} from "react-bootstrap";
import classnames from 'classnames';
import {useGlobalContext} from "../../../_common/contexts/GlobalContext";
import styles from '../styles.module.scss';
import themeStyles from '../../../_common/styles/theme.module.scss';

export const DropdownButton = ({
                                 icon,
                                 buttonLabel,
                                 disabled = false,
                                 items,
                               }) => {
  const {isGlassTheme} = useGlobalContext();

  const CustomToggle = React.forwardRef(({children, onClick}, ref) => (
    <button
      ref={ref}
      onClick={(e) => {
        e.preventDefault();
        onClick(e);
      }}
      className={classnames(styles.dropdownButton,
        isGlassTheme ? themeStyles.filter : themeStyles.noFilter,
        isGlassTheme ? themeStyles.jump : themeStyles.noJump,
      )}
      disabled={disabled}
    >
      {icon && <img src={icon} alt="upload" className="w-20px mr-2"/>}
      <span>{buttonLabel}</span>
    </button>
  ));

  const CustomDDItem = React.forwardRef(
    ({children, style, className, 'aria-labelledby': labeledBy, onClick}, ref) => (
      <label
        ref={ref}
        className={classnames('dropdown-item cursor-pointer', styles.selectItem)}
      >
        {children}
      </label>
    )
  );

  return (
    <div>
      <Dropdown>
        <Dropdown.Toggle
          as={CustomToggle}
          variant="light"
          id="dropdown-basic"
        />
        <Dropdown.Menu style={{
          overflowY: 'auto',
          overflowX: 'hidden',
          maxHeight: '300px',
          border: '1px solid rgb(56, 189, 248)',
        }}
        >
          {items.map(item => {
            return (
              <Dropdown.Item as={CustomDDItem}>
                {item}
              </Dropdown.Item>
            )
          })}
        </Dropdown.Menu>
      </Dropdown>
    </div>
  )
}
